function multicolumnSlider(){
    const prevs = window.document.querySelectorAll('.js_multicolumn-prev');
    const nexts = window.document.querySelectorAll('.js_multicolumn-next');
    const columns = window.document.querySelectorAll('.js_multicolumn-container');

    if( !nexts.length || !prevs.length || !columns) return


    let options = {
        rootMargin: "0px",
        threshold: 0.75,
    };

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            const { target } = entry;

            if (entry.intersectionRatio >= 0.75) {
                target.classList.add('current-snap')
            } else {
                target.classList.remove('current-snap')
            }
        });
    };

    const observer = new IntersectionObserver(callback, options);

    columns.forEach(colum => {
        observer.observe(colum);
    })

    prevs.forEach(prev => {
        prev.addEventListener('click',function(){
            this.parentElement.previousSibling.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        })
    })
    nexts.forEach(next => {
        next.addEventListener('click',function(){
            this.parentElement.nextElementSibling.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        })
    })
}
window.addEventListener('load',multicolumnSlider);